export default function ResourcesDetails() {
    return (
      <div>

<div className="general-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
<h2>Local Area Resources</h2>
</div>

{/*End Large Image Space*/}
{/*Start Main Content*/}
<div className="content-fluid">

<div className="mb-960-center-container mid-side-outlines">
    {/*Full Width Element*/}
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <h4>Borough Orginizations</h4>
            <ul>
            <li>Actors Network Of Bucks County: <a href="http://www.actorsnetbucks.org">http://www.actorsnetbucks.org&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                <li>Morrisville Fire Company Engine 98: <a href="https://www.morrisville98.com">https://www.morrisville98.com&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                <li>Morrisville Free Library: <a href="https://www.morrisvillepalibrary.org">https://www.morrisvillepalibrary.org&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
               
            </ul>
            <h4>Support &amp; Advocacy</h4>
            <ul>
                <li>Network of Victim Assistance (NOVA): <a href="https://novabucks.org/">https://novabucks.org/&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
            </ul>
            
        </div>
    </div>
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <h4>History</h4>
            <ul>
            <li>Delaware &amp; Lehigh National Heritage Corridor: <a href="https://delawareandlehigh.org">https://delawareandlehigh.org&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                <li>Friends Of The Delaware Canal: <a href="http://www.FODC.org"><br/>http://www.FODC.org&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                
                <li>Landmark Towns Of Bucks County: <a href="https://lmt.delawareandlehigh.org">https://lmt.delawareandlehigh.org&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
            </ul>
        </div>






    </div>
</div>



<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div><div className="gap-spacer"></div>
</div>
</div>

  </div>
    )
}
